/**
 */

define('directives/myservices/callbackUrl/callbackUrl.directives',['app', 'mainCons'], function (app, mainCons) {
    app.directive('callbackUrl', ['HuaweiTrade', 'payService', function (HuaweiTrade, payService) {
        var timeout;
        return {
            restrict: 'E',
            replace: true,
            require: "?ngModel",
            scope: {
                model: "=",
                packageForm: "="
            },
            templateUrl: '../refactor/directives/myservices/callbackUrl/callbackUrl.template.html',
            link: function ($scope, $element, attrs, ngModelCtrl) {
                $scope.regexp = mainCons.servicesConstant.regexp;
                $scope.testOauthRedirectUri = testOauthRedirectUri;
                $scope.initData = qryCbUrl;
                $scope.model.selected.callbackUrl = "";

                $scope.validOauthRedirectUri = (function () {
                    var regexp = new RegExp($scope.regexp.oauthRedirectUri);
                    return {
                        test: function (value) {
                            //验证是否以http或https开头
                            var regExpErrorX = "回调地址应该以http://或者https://开头";
                            var regExpErrorY = "回调地址不能包含字符'?'";
                            var regExpErrorT = "回调地址不合法，请重新输入。";
                            var regExpErrorP = "，不能包含字符'?'";

                            if (!regexp.test(value)) {
                                $scope.validCallbackUrlText = regExpErrorT;
                                if (value.substring(0, 7) != 'http://' && value.substring(0, 8) != 'https://') {
                                    $scope.validCallbackUrlText = regExpErrorX;
                                }
                                if (value.indexOf('?') != -1) {
                                    if ($scope.validCallbackUrlText != regExpErrorT) {
                                        $scope.validCallbackUrlText += regExpErrorP;
                                    } else {
                                        $scope.validCallbackUrlText = regExpErrorY;
                                    }
                                }
                                return false;
                            } else {
                                if (value.indexOf('?') != -1) {
                                    $scope.validCallbackUrlText = regExpErrorY;
                                    return false;
                                }
                            }
                            return regexp.test(value) && value.substring(value.length - 1) != '\\';
                        }
                    }
                })();

                function testOauthRedirectUri(callbackUrl) {
                    payService.testRedirectUri(callbackUrl);
                }

                function qryCbUrl() {
                    var prodID = $scope.model.product.appInfo.appID;
                    var signParams2 = {
                        params: {
                            content: "applicationID=" + prodID,
                            signtype: 'HMAC',
                            keytype: 'trade-hmacsha256'
                        }
                    };
                    if ($scope.model.serviceItem != 32) {
                        HuaweiTrade.sign(signParams2).then(function (data1) {
                            var res = angular.fromJson(data1);
                            if (res.returnCode === '0') {
                                var qryParams = {
                                    params: {
                                        applicationID: prodID,
                                        signType: 'HMAC',
                                        sign: res.sign
                                    }
                                };
                                HuaweiTrade.qryUserInfo(qryParams).then(function (data2) {
                                    var res2 = angular.fromJson(data2);
                                    if (res2.returnCode === '0') {
                                        if (res2.url) {
                                            //回调地址
                                            $scope.model.selected.callbackUrl = res2.url.trim() || '';
                                        }
                                    }
                                });

                            }
                        });
                    }


                }
            }
        }
    }]);
});

